import Vue from 'vue'
import Vuex from 'vuex'
import { fetchSiteData, fetchPosts, calcSubTotal, countCartItems, mergeMainMenu, getVersion } from '../api/methods'
import Storage from 'vue-ls'
import { hasEcwidCart, getCart } from '../api/ecwid';

const options = {
  namespace: 'ff_',
  name: 'ls',
  storage: 'local'
}

Vue.use(Storage, options);

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    main: {
      title: "Title",
      type: "page",
      image_src: "",
      terms: [],
      body: "<p>SEO Text</p> ",
      has_strapline: true,
      strapline: "Strapline",
      footer: {
        copyright__left: "",
        credits__right: ""
      }
    },
    mainMenu: [
      { title: 'Products', to: '/' },
      { title: 'About', to: '/about' },
      { title: 'Terms & Conditions', to: '/terms' }
    ],
    labels: {
      edition_info: 'Edition information',
      purchase: 'Purchase',
      checkout: 'Checkout',
      add_to_cart: 'Add to cart',
      added_to_cart: 'Added to cart',
      add_one_more: 'Add another',
      update_options: 'Update options',
      remove_one: 'Remove one',
      more_info_about: 'For more information about this section',
      none_requied: 'Remove altogether',
      total: "Total",
      subtotal: "Subtotal",
      vat: "VAT"
    },
    products: [],
    posts: [],
    cart: {
      cartId: "",
      items: [],
      tax: 0,
    },
    tax: 0,
    total: 0
  },
  getters: {
    main: state => state.main,
    posts: state => state.posts,
    products: state => state.products,
    pages: state => state.pages,
    mainMenu: state => state.mainMenu,
    labels: state => state.labels,
    cart: state => state.cart,
    subtotal: state => calcSubTotal(state.cart),
    tax: state => state.tax,
    total: state => state.total,
    numCartItems: state => countCartItems(state.cart),
    hasCart: state => countCartItems(state.cart) > 0
  },
  mutations: {
    setPosts(state, data) {
      state.posts = data;
    },
    setPages(state, data) {
      state.pages = data;
    },
    setMainMenu(state, data) {
      state.mainMenu = data;
    },
    setProducts(state, data) {
      state.products = data;
    },
    setMain(state, data) {
      state.main = data;
    },
    setCart(state, data) {
      state.cart = data;
    },
    setTaxTotal(state, data) {
      if (data.tax) {
        state.tax = data.tax;
        state.total = data.total;
      }
    }
  },
  actions: {
    getSiteData: async (store, fromCache) => {
      const expiryMillisecs = 60 * 60 * 1000;
      const version = getVersion();
      const storedVersion = parseFloat(Vue.ls.get('version', 1));
      const refresh = fromCache === false || (storedVersion < version);
      let data = refresh ? null : Vue.ls.get('site_data');
      let cached = false;
      if (!data) {
        data = await fetchSiteData();
        if (data.valid) {
          Vue.ls.set('site_data', data, expiryMillisecs);
          Vue.ls.set('version', version);
        }
      } else {
        cached = true;
      }
      if (data.valid) {
        if (data.numProducts > 0) {
          store.commit('setProducts', data.products);
        }
        if (data.numPages > 0) {
          store.commit('setPages', data.pages)
        }
        if (data.hasMain) {
          store.commit('setMain', data.main)
        }
        if (data.menus) {
          if (data.menus instanceof Array) {
            mergeMainMenu(data.menus, store);
          }
        }
      }
      data.cached = cached;
      return data;
    },
    getPosts: async (store) => {
      let data = Vue.ls.get('posts');
      if (!data) {
        data = await fetchPosts();
        if (data instanceof Array && data.length > 0) {
          Vue.ls.set('posts', data);
        }
      }
      store.commit('setPosts', data);
      return data;
    },
    updateCart: async (store, cart) => {
      store.commit('setCart', cart);
      if (cart.items) {
        if (cart.items instanceof Array) {
          cart.items = cart.items.filter(item => {
            if (item.product) {
              let p = store.getters.products.find(pr => pr.productId === item.product.id)
              if (p) {
                item.product.priceGross = p.priceGross;
              } else {
                item.product.priceGross = item.product.price;
              }
            }
            return item;
          });
        }
      }
      if (hasEcwidCart()) {
        getCart().calculateTotal(order => {
          store.commit('setTaxTotal', order);
        });
      }
      return cart;
    }
  }

});